var _path, _mask, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMiniBasketResting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M10.135 21.73c.287 1.66.991 3.26 2.114 4.63l6.345-6.344-1.96-1.959c-.06.063-.114.133-.177.197-1.801 1.8-4.004 2.95-6.322 3.476zM10 19.702c1.847-.475 3.596-1.423 5.04-2.866.063-.064.116-.133.177-.197l-2.968-2.968c-1.439 1.756-2.182 3.885-2.249 6.031zM16.477 15.063c.979-1.499 1.555-3.184 1.731-4.905-1.625.296-3.193.992-4.54 2.095l2.81 2.81zM17.914 16.5l2.098 2.098 6.345-6.344c-1.782-1.461-3.95-2.208-6.13-2.254-.17 2.291-.942 4.54-2.313 6.5zM29.962 18.857c-.214-1.854-.939-3.661-2.188-5.185l-6.344 6.344 1.977 1.977c1.903-1.7 4.18-2.747 6.555-3.136z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "d5wa94zlfa",
    width: 6,
    height: 7,
    x: 24,
    y: 20,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M24.824 20.875H30v5.486h-5.176v-5.486z",
    clipRule: "evenodd"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d5wa94zlfa)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M27.775 26.36c1.316-1.606 2.058-3.526 2.225-5.485-1.87.356-3.66 1.208-5.176 2.535l2.95 2.95z",
    clipRule: "evenodd"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#6C7281",
    fillRule: "evenodd",
    d: "M21.196 29.963c1.845-.22 3.643-.941 5.161-2.184l-2.922-2.922c-1.205 1.518-1.948 3.281-2.239 5.106zM20.012 21.434l-6.345 6.345c1.61 1.32 3.536 2.062 5.5 2.226.31-2.355 1.248-4.643 2.84-6.576l-1.995-1.995z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMiniBasketResting);
export default __webpack_public_path__ + "static/media/icon_mini_basket_resting.b14cd55111bbeab7459265a269aea375.svg";
export { ForwardRef as ReactComponent };